(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  const atcBtn  = document.getElementById('hero-atc-btn');
  const qtyInput = document.getElementById('hero-qty');
  const qtyDec  = document.getElementById('hero-qty-dec');
  const qtyInc  = document.getElementById('hero-qty-inc');
  if (!atcBtn) return;

  qtyDec?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value, 10);
    if (v > 1) qtyInput.value = v - 1;
  });

  qtyInc?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value, 10);
    if (v < 10) qtyInput.value = v + 1;
  });

  atcBtn.addEventListener('click', async () => {
    const variantId = atcBtn.dataset.variantId;
    if (!variantId) return;

    const qty = parseInt(qtyInput?.value || '1', 10);

    atcBtn.disabled = true;
    const original = atcBtn.textContent;
    atcBtn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty }),
      });
      if (!res.ok) throw new Error(await res.text());

      const cart = await fetch('/cart.js').then(r => r.json());
      if (typeof window.refreshCartUI === 'function') window.refreshCartUI(cart);

      const drawer  = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      if (drawer) {
        drawer.classList.add('is-open');
        overlay?.classList.add('is-open');
        overlay?.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      atcBtn.textContent = '✓ Added!';
      setTimeout(() => { atcBtn.textContent = original; atcBtn.disabled = false; }, 1800);
    } catch (err) {
      console.error(err);
      atcBtn.disabled = false;
      atcBtn.textContent = original;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matcha-journey"] && !Shopify.designMode) return;
  try {
    

(function () {

  var sectionEl = document.querySelector('.mja');
  if (!sectionEl) return;

  var entered = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        entered.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  sectionEl.querySelectorAll('[data-enter], .mja__compare-row').forEach(function (el) {
    entered.observe(el);
  });

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function runCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var duration = 1800;
    var start = null;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var val = Math.round(easeOutCubic(p) * target);
      el.textContent = prefix + val.toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var countersEl = sectionEl.querySelector('.mja__counters');
  if (countersEl) {
    var counterObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        countersEl.querySelectorAll('.mja__counter-num[data-target]').forEach(runCounter);
        counterObs.disconnect();
      }
    }, { threshold: 0.35 });
    counterObs.observe(countersEl);
  }

  var canvas = sectionEl.querySelector('.mja__particles');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var W, H, particles;

  function resize() {
    W = sectionEl.offsetWidth;
    H = sectionEl.offsetHeight;
    canvas.width = W;
    canvas.height = H;
  }

  function makeParticle() {
    return {
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1.4 + 0.4,
      vy: -(Math.random() * 0.35 + 0.08),
      vx: (Math.random() - 0.5) * 0.22,
      alpha: Math.random() * 0.35 + 0.08
    };
  }

  function init() {
    resize();
    particles = [];
    for (var i = 0; i < 70; i++) {
      var p = makeParticle();
      p.y = Math.random() * H;
      particles.push(p);
    }
  }

  var rafId;
  function draw() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(74,222,128,' + p.alpha + ')';
      ctx.fill();
      p.x += p.vx;
      p.y += p.vy;
      if (p.y < -8) {
        var fresh = makeParticle();
        fresh.y = H + 8;
        particles[i] = fresh;
      }
    }
    rafId = requestAnimationFrame(draw);
  }

  var visObs = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      if (!rafId) {
        init();
        draw();
      }
    } else {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }
  }, { threshold: 0.01 });
  visObs.observe(sectionEl);

  window.addEventListener('resize', function () {
    resize();
    if (particles) {
      particles.forEach(function (p) {
        if (p.x > W) p.x = Math.random() * W;
        if (p.y > H) p.y = Math.random() * H;
      });
    }
  });

})();


  } catch(e) { console.error(e); }
})();
})();
